import React from "react";
import PropTypes from "prop-types";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Tooltip from "storybookComponents/Tooltip";
import Typography from "storybookComponents/Typography";
import Icon from "storybookComponents/Icon";
import debounce from "lodash/debounce";
import { analyzeDateUTC, parseISO } from "./date_utils";

const styles = theme => ({
  setPointer: {
    cursor: "pointer"
  },
  lineHeight: {
    lineHeight: 1.2
  },
  spacing: {
    marginBottom: theme.spacing_unit.xs
  },
  displayBlock: {
    display: "block",
    marginTop: theme.spacing_unit.xs
  }
});

function getBody(body) {
  var splitBody = body.split(" ");
  var time = splitBody.find(
    e =>
      e.includes("-") &&
      e.includes(":") &&
      e.includes("T") &&
      e.includes("Z") &&
      !e.includes(".")
  );
  var convertedTime = time && parseISO(time, "MM/DD/YYYY, h:mm A");
  var result = splitBody.map(e =>
    e === time ? convertedTime : e === time + "." ? convertedTime + "." : e
  );
  return result.join(" ");
}

function NotificationBellUnit({
  classes: { setPointer, lineHeight, spacing, displayBlock },
  mouseOver,
  show_close_notification,
  handleClose,
  handleClick,
  notification: { id, header, body, status, ...n },
  context_id
}) {
  const [createdAt, set_Date] = React.useState(null);

  React.useEffect(() => set_Date(analyzeDateUTC(n.createdAt)), [n.createdAt]);

  return (
    <ListItem
      divider
      key={id}
      className={setPointer}
      onMouseOver={debounce(e => mouseOver(id), 150)}
      onMouseLeave={debounce(e => mouseOver(null), 150)}
    >
      <ListItemText
        primary={
          <Typography
            type="body1"
            font_weight={600}
            className={lineHeight}
            gutterBottom
          >
            {header}
          </Typography>
        }
        secondary={
          <>
            <Typography component="span" type="body1" className={lineHeight}>
              {getBody(body)}
            </Typography>
            <Typography
              component="span"
              className={displayBlock}
              type="body2"
              color="deepGrey"
              font_weight={300}
            >
              {createdAt}
            </Typography>
          </>
        }
        onClick={e => handleClick(e, context_id, { id, header, body, status, ...n })}
      />
      {show_close_notification === id && (
        <Tooltip tooltip_text="Mark as Read" placement="left">
          <Icon type="icon-e-remove" onClick={e => handleClose(id, status, context_id)} />
        </Tooltip>
      )}
    </ListItem>
  );
}

NotificationBellUnit.propTypes = {
  classes: PropTypes.object,
  notification: PropTypes.shape({
    createdAt: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]),
    id: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  })
};

export default React.memo(withStyles(styles)(NotificationBellUnit));
